"use client";

import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {useTranslation} from "@/shared/i18n";
import {ButtonBase} from "@/shared/ui/buttons/button-base";
import {assetPath} from "@/shared/utils/asset-path";

import {RentalOffer, type RentalOfferProps} from "../rental-offer";

export interface RentalOfferShuffleProps extends RentalOfferProps {
    showShuffleButton: boolean;
    onShuffle: () => void;
}

export function RentalOfferShuffle({showShuffleButton, onShuffle, loading, ...rest}: RentalOfferShuffleProps): JSX.Element {
    const {t} = useTranslation("common");

    return (
        <RentalOffer loading={loading} {...rest}>
            {showShuffleButton && (
                <div className="destination__button-wrap">
                    <ButtonBase
                        variant="secondary-outline"
                        size="xs-s"
                        width="fit"
                        onClick={onShuffle}
                        loading={loading.isInitial}
                        disabled={loading.isFiltering || loading.isInitial}
                    >
                        {t("shuffle")}
                        <SmartImage src={assetPath("/images/icons/icon-shuffle.svg")} alt="shuffle" width={16} height={16} />
                    </ButtonBase>
                </div>
            )}
        </RentalOffer>
    );
}
